import { render, staticRenderFns } from "./discount-form.vue?vue&type=template&id=875c4472&"
import script from "./discount-form.vue?vue&type=script&lang=js&"
export * from "./discount-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports